import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../img/logo.svg'
import { withRouter } from 'react-router-dom'
import { Button, Fab } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { makeStyles } from '@material-ui/styles'
import { darken } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    fab: {
        background: 'linear-gradient(45deg, #e29d5c 30%, #e2b753 90%)',
        '&:hover, &:focus': {
            background: darken('#d7bb77', .15),
        }
    },
}))

const Header = ({ location }) => {

    const authInfo = useSelector(state => state.authInfo)
    const styles = useStyles()

    const handleLogout = () => {
        localStorage.clear()
        window.location.reload()
    }

    return (
        <nav id='desktop-menu'>
            <img src={logo} alt='' />

            <ul>
                <li className={location.pathname === '/' ? 'current-page menu-link' : 'menu-link'}>
                    <Link to='/' className='text-white'>خانه</Link>
                </li>

                <li className={location.pathname === '/programmers' ? 'current-page menu-link' : 'menu-link'}>
                    <Link to='/programmers' className='text-white'>برنامه نویس ها</Link>
                </li>

                <li className={location.pathname === '/people' ? 'current-page menu-link' : 'menu-link'}>
                    <Link to='/people' className='text-white'>کاربران عادی</Link>
                </li>

                {isEmpty(authInfo)
                    ? <li className={location.pathname === '/login' ? 'current-page menu-link' : 'menu-link'}>
                        <Link to='/login' className='text-white'>ورود</Link>
                    </li>
                    : null
                }

                {isEmpty(authInfo)
                    ? <li className={location.pathname === '/register' ? 'current-page menu-link' : 'menu-link'}>
                        <Link to='/register' className='text-white'>ثبت نام</Link>
                    </li>
                    : null
                }

                {!isEmpty(authInfo)
                    ? <li>
                        <Link to='/dashboard'>
                            <Fab
                                variant='extended'
                                className={styles.fab}
                                style={location.pathname === '/dashboard'
                                    ? {
                                        boxShadow: '0px 0px 10px 0px #00AD9F'
                                    }
                                    : null
                                }
                            >
                                <section className='dashboard-icon'>
                                    <i className="fas fa-user-circle"></i>
                                    <span>{authInfo.fullname}</span>
                                </section>
                            </Fab>
                        </Link>
                    </li>
                    : null
                }
            </ul>

            {!isEmpty(authInfo)
                ? <Button
                    className='mr-3'
                    variant='contained'
                    onClick={handleLogout}
                    color='secondary'
                ><strong>خروج</strong></Button>
                :
                null
            }
        </nav>
    )
}

export default withRouter(Header)